import { ELoadingType } from '@qsp-ui-library/models/enums/loading-type.enum';
import { QimaColorService } from '@qsp-ui-library/services/exported-services/qima-color/qima-color.service';
import { QimaSpinnerService } from '@qsp-ui-library/services/exported-services/qima-spinner/qima-spinner.service';
import { QimaThreeSquaresLoaderService } from '@qsp-ui-library/services/exported-services/qima-three-squares-loader/qima-three-squares-loader.service';
import { AppOverlayService } from '@qsp-ui-library/services/modal-services/app-overlay/app-overlay.service';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { QimaOptionalType } from '@qima/ngx-qima';

@Component({
  standalone: false,
  selector: 'app-overlay',
  templateUrl: './overlay.component.html',
  styleUrls: ['./overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverlayComponent {
  /**
   * @description
   * The loading type
   * @type {QimaOptionalType<ELoadingType>}
   * @default ELoadingType.GIF
   */
  @Input('overlayLoadingType')
  public loadingType: QimaOptionalType<ELoadingType> = ELoadingType.GIF;

  /**
   * @description
   * Is loading
   * @type {QimaOptionalType<boolean>}
   * @default false
   */
  @Input('overlayIsLoading')
  public isLoading: QimaOptionalType<boolean> = true;

  @Output()
  public readonly overlayClick: EventEmitter<MouseEvent | Event> = new EventEmitter<MouseEvent | Event>();

  public loadingGifSrc: string = 'assets/images/loading_300.gif';

  public constructor(
    public readonly overlayService: AppOverlayService,
    public readonly threeSquaresLoaderService: QimaThreeSquaresLoaderService,
    public readonly spinnerService: QimaSpinnerService,
    public readonly qimaColor: QimaColorService
  ) {}

  public onClick(event: Readonly<MouseEvent | Event>): void {
    this._emitClick(event);
  }

  public onEnter(event: Readonly<MouseEvent | Event>): void {
    this._emitClick(event);
  }

  private _emitClick(event: Readonly<MouseEvent | Event>): void {
    this.overlayClick.emit(event);
  }
}
